import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import { COUNTRY_PHONE_CODE, ACCOUNT_TYPES, INDIA_ACCOUNT_TYPES, BENETYPES, EMAIL } from "../../appconstants";
import {
  CancelButton,
  FlexContainer,
  H1Text,
  Hr,
  Input,
  InputWrapper,
  LabelText, SpanText,
  SubmitButton,
  Text
} from "../../design";
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';

type Props = {
  errorMsg: string,
  errorHeader: string,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  customerDisabled: boolean,
  alpha2: string,
  disableButtonText: string,
  planStartDate: Object,
  currentDateObject: Object,
  cancel: Function,
  showCancelBtn: boolean,
  requiredPhone: boolean,
  cancelButtonText: string,
  transferType: String,
  issuerType: String,
}

const TransferLink = (props: Props) => {
  const { submit, preFillCustomer, customerDisabled,
    headerText, buttonText, errorHeader, errorMsg, transferType, issuerType,
    customerValidation, alpha2, disableButtonText, requiredPhone, planStartDate, currentDateObject, showCancelBtn, cancel, cancelButtonText } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';
  const ifscRegex = ((alpha2 === 'IN') ? /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/ : /[0-9]{9}/);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
  } = useForm();

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    }
  }, [reset, preFillCustomer]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if(!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const customStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      marginTop: "8px"
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const phoneCustomStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important'
    }),
  };

  const disableStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const onSubmit = data => {
    const { name, email, phone, countryCallingCode, accountType, accountNumber, vpa, routingNumber } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const Route = routingNumber.trim();
    const AccountNum = accountNumber.trim();
    let beneType = BENETYPES.BANK;
    if ((issuerType === 'ICICI') || (issuerType === 'Cashfree')) {
      if (transferType === 'UPI') {
        beneType = BENETYPES.VPA;
      } else {
        beneType = BENETYPES.BANK;
      }
    }
    let TransferLinkData;
    if (transferType === 'UPI') {
      TransferLinkData = { issuerBank: { beneType, vpa } };
    } else {
      TransferLinkData = { issuerBank: { accountType: accountType.value === "CURRENT ACCOUNT" ? "CURRENT" : accountType.value, beneType, accountNumber: AccountNum, routingNumber: Route, } };
    }
    const finalData = { ...data, phoneNumber, customer, TransferLinkData };
    if (submit) { submit(finalData) }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  return (
    <>
      <H1Text
        className="px-1 px-md-4 mb-0"
      >
        {headerText || "RECEIVE FUNDS BY BANK"}
      </H1Text>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)(e);
        }}
        onChange={() => setShowErrorMessage(false)}
        style={{
          width: '100%',
        }}
      >
        <FlexContainer
          flexDirection="column"
        >
          <div className="px-1 px-md-4 mt-2">
            <LabelText>
              Name
            </LabelText>
            <Controller
              defaultValue={""}
              color={errors.name ? "red" : "inherit"}
              marginBottom="0px"
              control={control}
              name="name"
              placeholder="Enter your name"
              rules={customerValidation && {
                required: 'This field is required'
              }}
              as={<Input
                readOnly={customerDisabled}
                style={{
                  background: customerDisabled ? BACKGROUND_COLOR : '',
                  color: customerDisabled ? COLOR : ''
                }}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="name"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              E-Mail
            </LabelText>
            <Controller
              marginBottom="0px"
              defaultValue={""}
              color={errors.email ? "red" : "inherit"}
              control={control}
              name="email"
              placeholder="Enter your email address"
              rules={customerValidation && {
                required: 'This field is required',
                pattern: {
                  value: EMAIL.DEFAULT_REGEX,
                  message: 'The email is invalid',
                },
              }}
              as={<Input
                readOnly={customerDisabled}
                style={{
                  background: customerDisabled ? BACKGROUND_COLOR : '',
                  color: customerDisabled ? COLOR : ''
                }}
              />}
            />
            <ErrorMessage
              errors={errors}
              name="email"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <LabelText>
              Phone
            </LabelText>
            <InputWrapper className="row" display="flex" marginTop="8px" borderRadius="4px" width='299px'>
              <Controller
                defaultValue={""}
                color={errors.countryCallingCode ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="countryCallingCode"
                placeholder="select"
                rules={requiredPhone && {
                  required: 'Calling Code is required'
                }}
                as={<Select
                  className="col-4 px-0 border-0"
                  menuPlacement="auto"
                  isSearchable={!customerDisabled}
                  menuIsOpen={customerDisabled ? false : undefined}
                  theme={theme => ({
                    ...theme,
                    borderRadius: "4px 0 0 4px",
                    boxShadow: 0
                  })}
                  getOptionLabel={(option) => option.value}
                  styles={customerDisabled ? disableStyles : phoneCustomStyles}
                  options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
              />
              <Controller
                className="col"
                defaultValue={""}
                color={errors.phone ? "red" : "inherit"}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                paddingRight="0"
                control={control}
                name="phone"
                rules={requiredPhone && {
                  required: 'This field is required',
                  validate: isPhoneNumberValidate
                }}
                as={<NumberFormat
                  type="tel"
                  allowNegative={false}
                  decimalScale={0}
                  readOnly={customerDisabled}
                  borderRadius="none"
                  style={{
                    background: customerDisabled ? BACKGROUND_COLOR : '',
                    color: customerDisabled ? COLOR : ''
                  }}
                />}
                placeholder="Enter your phone number"
                customInput={Input}
              />
            </InputWrapper>
            <ErrorMessage
              errors={errors}
              name="phone"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
            <Hr />
            {
              transferType === 'UPI' ? (
                <>
                  <LabelText>
                    UPI Id
                  </LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.vpa ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="vpa"
                    placeholder="Enter your upi id"
                    rules={{
                      required: 'This field is required',
                      pattern: {
                        value: /^\w.+@\w+$/,
                        message: 'The upi id is invalid',
                      },
                    }}
                    as={<Input className="w-100" />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="vpa"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                </>
              ) : (
                <>
                  <LabelText>
                    Account Type
                  </LabelText>
                  <div style={{
                    width: "299px"
                  }}>
                    <Controller
                      defaultValue={""}
                      color={errors.accountType ? "red" : "inherit"}
                      marginBottom="0px"
                      control={control}
                      name="accountType"
                      placeholder="Select account type"
                      rules={{
                        required: 'Account type is required'
                      }}
                      as={<Select
                        className="px-0 border-0"
                        theme={theme => ({
                          ...theme,
                          borderRadius: "4px",
                          boxShadow: 0,
                        })}
                        getOptionLabel={(option) => option.value}
                        styles={customStyles}
                        options={alpha2 === "IN" ? INDIA_ACCOUNT_TYPES.map(value => { return { value } }) : ACCOUNT_TYPES.map(value => { return { value } })} />}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="accountType"
                      render={({ message }) => (
                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                      )}
                    />
                  </div>
                  <LabelText>
                    Account Number
                  </LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.accountNumber ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="accountNumber"
                    placeholder="Enter account number"
                    rules={{
                      required: 'This field is required',
                      pattern: {
                        value: /^\s*[0-9]{6,17}\s*$/,
                        message: 'The account number is invalid',
                      },
                    }}
                    as={Input}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="accountNumber"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  <LabelText>
                    {(alpha2 && alpha2 === 'IN') ? 'IFSC Code' : 'Routing Number'}
                  </LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.routingNumber ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    name="routingNumber"
                    placeholder={(alpha2 && (alpha2 === 'IN')) ? 'Enter Code' : 'Routing Number'}
                    rules={customerValidation && {
                      required: 'This field is required',
                      pattern: {
                        value: ifscRegex,
                        message: (alpha2 && (alpha2 === 'IN')) ? 'The ifsc code is invalid' : 'The routing number is invalid',
                      },
                    }}
                    as={Input}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="routingNumber"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                </>
              )
            }
            <div className="px-1 px-md-4">
              <FlexContainer
                width="100%"
                alignItems="center"
                justifyContent="space-between"
              >
                {
                  showCancelButton && cancel &&
                  <SpanText
                    onClick={onCancel}
                    cursor="pointer"
                    color="#40A9FF"
                    className="cursor-pointer m-3 pt-3"
                  >{cancelButtonText || "Cancel"}</SpanText>
                }
                {disableButtonText && (planStartDate < currentDateObject) ?
                  (
                    <SubmitButton
                      type="submit"
                      disabled
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                  : (
                    <SubmitButton
                      type="submit"
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                }
              </FlexContainer>
              {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} />}
              {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
            </div>
          </div>
        </FlexContainer>
      </form>
    </>
  )
};

export default TransferLink;
